import { configureStore } from "@reduxjs/toolkit";

import uiData from "./ui-slice";
import apiConfig from "./apiConfig-slice";
import qCardCompletedCourses from "./qCardCompletedCourses-slice";
import qCardTrainingHours from "./qCardTrainingHours-slice";
import qCardCertificates from "./qCardCertificates-slice";
import cardRunningCourses from "./cardRunningCourses-slice";
import cardRunningActions from "./cardRunningActions-slice";
import cardNotifications from "./cardNotifications-slice";
import donutChart from "./donutChart-slice";

import MyCourses from "./MyCourses-slice";
import CourseDetails from "./CourseDetails-slice";
import ActionDetails from "./ActionDetails-slice";
import CourseCompletedDetails from "./CourseCompletedDetails-slice";
import CoursesCatalog from "./CoursesCatalog-slice";
import CatalogDetails from "./CatalogDetails-slice";

const store = configureStore({
    reducer: {
        uiData: uiData.reducer,
        apiConfigData: apiConfig.reducer,
        qCardCompletedCoursesData: qCardCompletedCourses.reducer,
        qCardTrainingHoursData: qCardTrainingHours.reducer,
        qCardCertificatesData: qCardCertificates.reducer,
        cardRunningCoursesData: cardRunningCourses.reducer,
        cardRunningActionsData: cardRunningActions.reducer,
        cardNotificationsData: cardNotifications.reducer,
        donutChartData: donutChart.reducer,
        MyCoursesData: MyCourses.reducer,
        CourseDetailsData: CourseDetails.reducer,
        ActionDetailsData: ActionDetails.reducer,
        CourseCompletedDetailsData: CourseCompletedDetails.reducer,
        CoursesCatalogData: CoursesCatalog.reducer,
        CatalogDetailsData: CatalogDetails.reducer,
    },
});

export default store;